import { AspectRatio } from '@livecontrol/core-ui';
import _ from 'lodash';
import React from 'react';
import type { UntitledEvent } from '../../graphql';

export const Preview = ({
  untitledEvent
}: {
  untitledEvent?: UntitledEvent;
}): React.ReactElement => {
  if (!untitledEvent) {
    return <div className='text-white'>Could not load event details</div>;
  }

  return (
    <AspectRatio
      ratio={3 / 2}
      style={{
        borderRadius: 4,
        backgroundSize: 'cover',
        backgroundImage: `url('${
          untitledEvent.thumbnail_url ??
          '/assets/fallback-background.jpeg'
        }')`,
        boxShadow: 'inset 0px 50px 20px -20px var(--black60)'
      }}
    />
  );
};
